import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { colors } from '../../lib/colors';
import { Body2Regular, Head4, CaptionRegular, Body3Regular } from '../../lib/font';
import { Col, Row } from '../../lib/utils';
import WhiteRoundButton from '../../components/Button/WhiteRoundButton';
import ColorRoundButton from '../../components/Button/ColorRoundButton';

const PROD_ORIGIN = 'https://www.rappomanager.com';

const BusinessAdminPage = () => {
    const navigate = useNavigate();
    const [adminId, setAdminId] = useState('');
    const [isCopied, setIsCopied] = useState(false);

    const inputPaymentUrl = `${PROD_ORIGIN}/input-payment/${adminId}`;

    const handleGoToCardRegistration = () => {
        if (adminId.trim()) {
            navigate(`/input-payment/${adminId.trim()}`);
        }
    };

    const copyToClipboard = async (text: string): Promise<boolean> => {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            return true;
        }
    };

    const handleCopyUrl = async () => {
        if (!adminId.trim()) return;
        const ok = await copyToClipboard(inputPaymentUrl);
        if (ok) {
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        }
    };

    return (
        <Col
            style={{
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                backgroundColor: '#F5F7FA',
                padding: 16,
            }}
        >
            <Col
                style={{
                    width: '100%',
                    maxWidth: 520,
                    borderRadius: 20,
                    backgroundColor: '#FFFFFF',
                    boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
                    padding: '32px 20px',
                    alignItems: 'center',
                }}
            >
                <Head4 style={{ color: colors.LAVEL_4, fontSize: 22 }}>카드 등록</Head4>
                <Body3Regular
                    style={{
                        color: colors.LAVEL_2,
                        marginTop: 8,
                        textAlign: 'left',
                        alignSelf: 'flex-start', // 왼쪽 정렬
                    }}
                >
                    라포 PC 로그인 시 사용하는 아이디를 입력해주세요
                </Body3Regular>

                <Col style={{ width: '100%', marginTop: 28 }}>
                    <Body2Regular style={{ color: colors.LAVEL_4, marginBottom: 8 }}>아이디</Body2Regular>
                    <input
                        type="text"
                        value={adminId}
                        onChange={(e) => {
                            setAdminId(e.target.value.trim());
                            setIsCopied(false);
                        }}
                        placeholder="라포 관리자 PC웹 로그인 아이디"
                        style={{
                            width: '100%',
                            height: 48,
                            borderRadius: 12,
                            border: '1px solid #E2E8F0',
                            paddingLeft: 16,
                            fontSize: 16,
                            backgroundColor: '#F8FAFC',
                            outline: 'none',
                        }}
                    />
                </Col>

                {adminId.trim() && (
                    <Col
                        style={{
                            width: '100%',
                            marginTop: 20,
                            padding: '18px 20px',
                            borderRadius: 12,
                            backgroundColor: '#F8FAFC',
                            border: '1px solid #E2E8F0',
                        }}
                    >
                        <CaptionRegular style={{ color: colors.LAVEL_2, marginBottom: 8 }}>카드 등록 링크</CaptionRegular>
                        <Body3Regular
                            style={{
                                color: colors.primary,
                                wordBreak: 'break-all',
                                lineHeight: '22px',
                            }}
                        >
                            {inputPaymentUrl}
                        </Body3Regular>
                    </Col>
                )}

                <Row style={{ width: '100%', marginTop: 32, gap: 12, flexWrap: 'wrap' }}>
                    <WhiteRoundButton
                        text={isCopied ? '복사 완료!' : 'URL 복사'}
                        size="small"
                        callBack={handleCopyUrl}
                        isDisabled={!adminId.trim()}
                        isVisibleLeftImg={false}
                        isVisibleRightImg={false}
                        customStyle={{ width: 160, height: 44 }}
                    />
                    <ColorRoundButton
                        text="카드 등록하기"
                        size="small"
                        callBack={handleGoToCardRegistration}
                        isDisabled={!adminId.trim()}
                        customStyle={{ width: 200, height: 44 }}
                        isGradient={false}
                        disableHoverEffect={false}
                    />
                </Row>
            </Col>
        </Col>
    );
};

export default BusinessAdminPage;
